import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=a860b3da&scoped=true&"
import script from "./NoResults.vue?vue&type=script&lang=js&"
export * from "./NoResults.vue?vue&type=script&lang=js&"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=a860b3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a860b3da",
  null
  
)

export default component.exports